/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_dd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The calculator counts the exact number of calendar days between your two dates, then converts that into a years/months/days breakdown by walking the real calendar rather than dividing by 30 or 365. It also reports the total in weeks, and splits the range into weekdays versus weekend days.`)
};

const es_dd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La calculadora cuenta el número exacto de días de calendario entre tus dos fechas, luego convierte eso en un desglose de años/meses/días recorriendo el calendario real en lugar de dividir por 30 o 365. También reporta el total en semanas y divide el rango en días de semana versus días de fin de semana.`)
};

const de_dd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Rechner zählt die genaue Anzahl der Kalendertage zwischen Ihren zwei Daten, konvertiert dann diese in eine Aufschlüsselung nach Jahren/Monaten/Tagen, indem er den echten Kalender durchläuft, anstatt durch 30 oder 365 zu dividieren. Er berichtet auch die Gesamtzahl in Wochen und teilt die Spanne in Wochentage gegen Wochenendtage auf.`)
};

const nl_dd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De calculator telt het exacte aantal kalenderdagen tussen je twee datums, en converteert dat vervolgens in een uitsplitsing jaren/maanden/dagen door de echte kalender te doorlopen in plaats van te delen door 30 of 365. Het geeft ook het totaal in weken, en splitst het bereik in weekdagen versus weekenddagen.`)
};

const fr_dd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La calculatrice compte le nombre exact de jours calendaires entre vos deux dates, puis convertit cela en une ventilation années/mois/jours en parcourant le calendrier réel plutôt que de diviser par 30 ou 365. Elle rapporte également le total en semaines et divise la plage en jours de la semaine par rapport aux jours de fin de semaine.`)
};

const it_dd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il calcolatore conta il numero esatto di giorni di calendario tra le tue due date, quindi lo converte in un'analisi anni/mesi/giorni camminando nel calendario reale piuttosto che dividendo per 30 o 365. Riporta anche il totale in settimane e divide l'intervallo in giorni feriali rispetto ai giorni del fine settimana.`)
};

const pt_br2_dd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A calculadora conta o número exato de dias do calendário entre suas duas datas, depois converte isso em uma divisão anos/meses/dias caminhando pelo calendário real em vez de dividir por 30 ou 365. Ela também informa o total em semanas e divide o intervalo em dias úteis versus dias de fim de semana.`)
};

const pt_dd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A calculadora conta o número exato de dias do calendário entre as suas duas datas e depois converte isso numa decomposição de anos/meses/dias percorrendo o calendário real em vez de dividir por 30 ou 365. Também reporta o total em semanas e divide o intervalo em dias da semana em comparação com dias de fim de semana.`)
};

const ja_dd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`計算機は2つの日付間の正確なカレンダー日数をカウントし、30または365で割るのではなく実際のカレンダーを歩むことで、それを年/月/日の内訳に変換します。また、週単位の合計を報告し、範囲を平日と週末日に分割します。`)
};

const zh_dd_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`计算器会精确统计你所选两个日期之间的日历天数，然后通过按真实日历逐步推算（而不是简单除以30或365）将其转换为年/月/日的明细。它还会给出折算成周数的总计，并将这段时间划分为工作日和周末天数。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const dd_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.dd_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("dd_faq1_a", locale)
	if (locale === "en") return en_dd_faq1_a(inputs)
	if (locale === "es") return es_dd_faq1_a(inputs)
	if (locale === "de") return de_dd_faq1_a(inputs)
	if (locale === "nl") return nl_dd_faq1_a(inputs)
	if (locale === "fr") return fr_dd_faq1_a(inputs)
	if (locale === "it") return it_dd_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_dd_faq1_a(inputs)
	if (locale === "pt") return pt_dd_faq1_a(inputs)
	if (locale === "ja") return ja_dd_faq1_a(inputs)
	return zh_dd_faq1_a(inputs)
};